import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-navtoggle', 'toggleMenu', 'Perjungti meniu');
Labels.set('ui-navtoggle', 'closeMenu', 'Uždaryti meniu');
Labels.set('ui-navtoggle', 'close', 'Uždaryti');
